import { render, staticRenderFns } from "./AnnouncementCloseHorizontal.html?vue&type=template&id=2da71a8e&scoped=true&"
import script from "./AnnouncementCloseHorizontal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementCloseHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementCloseHorizontal.scss?vue&type=style&index=0&id=2da71a8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da71a8e",
  null
  
)

export default component.exports